import React, { Component } from "react";
import { observer } from "mobx-react";

import { combineEventFilters } from "@formant/core/common/combineFilters";
import { distinct } from "@formant/core/common/distinct";
import { IEventFilter } from "@formant/core/model/IEventFilter";
import { IFilter } from "@formant/core/model/IFilter";
import { Uuid } from "@formant/core/model/Uuid";

import { annotationTemplateStore, eventStore } from "../../stores";
import { IMultiSelectOption, MultiSelect } from "../common/MultiSelect";

export interface IAnnotationTemplateSelectProps {
    value: Uuid[];
    filter: IEventFilter;
    context: IFilter;
    className?: string;
    onChange: (value: Uuid[]) => void;
}

@observer
export class AnnotationTemplateSelect extends Component<IAnnotationTemplateSelectProps> {
    private annotationTemplateIds: Uuid[] = [];
    public render() {
        const { value, filter, context, className, onChange } = this.props;
        const ids =
            eventStore.annotationTemplates(
                combineEventFilters(context, {
                    ...filter,
                    annotationTemplateIds: undefined,
                }),
            ) || this.annotationTemplateIds;
        this.annotationTemplateIds = ids;
        const options = distinct([...ids, ...value])
            .flatMap<IMultiSelectOption<Uuid>>(id => {
                const label = formatAnnotationIdDisplayName(id);
                if (!label) {
                    return [];
                }
                return [
                    {
                        value: id,
                        label,
                    },
                ];
            })
            .sort((a, b) => a.label?.localeCompare(b.label || "") || 0);
        if (options.length === 0) {
            return false;
        }
        return (
            <MultiSelect
                value={value}
                title="Annotation"
                options={options}
                className={className}
                onChange={onChange}
            />
        );
    }
}

function formatAnnotationIdDisplayName(id: Uuid) {
    const t = annotationTemplateStore.get(id);
    return (t && t.name) || undefined;
}
